import { useQuery as useQueryBase } from 'shared-ui';

export const useQuery = useQueryBase;
